import { createContext } from 'react'

import { LeaveConfirmationContextShape } from './LeaveConfirmationContextShape'

export const LeaveConfirmationContext = createContext<LeaveConfirmationContextShape>({})
